import { getAuth, sendPasswordResetEmail } from "@firebase/auth";
import { useEffect, useState } from "react";
import { AuthErrorMessages } from "../../Helpers/ToastMessages";

export default function ForgotPasswordViewModel() {
  const [email, setEmail] = useState("");
  const [EmailError, setEmailError] = useState(false);
  const [IsCheckError, setIsCheckError] = useState(false);
  const [IsPasswordResetEmailSend, setIsPasswordResetEmailSend] = useState();
  const [BtnLoader, setBtnLoader] = useState(false);

  useEffect(() => {
    if (IsCheckError) UIErrorHandling();
  }, [IsCheckError, email]);

  // Check email validation
  function isValidEmail(email) {
    return /\S+@\S+\.\S+/.test(email);
  }
  const UIErrorHandling = () => {
    let flag = 0;
    if (
      email === "" ||
      email === null ||
      email === undefined ||
      !isValidEmail(email)
    ) {
      setEmailError(true);
      flag++;
    } else {
      setEmailError(false);
    }
    return flag;
  };
  const ResetPassword = async () => {
    setIsCheckError(true);
    let flag = 0;
    flag = UIErrorHandling();
    if (flag === 0) {
      setBtnLoader(true);
      let auth = getAuth();
      sendPasswordResetEmail(auth, email)
        .then(() => {
          setIsPasswordResetEmailSend(true);
          setBtnLoader(false);
          return;
        })
        .catch((err) => {
          const errorCode = err.code;
          AuthErrorMessages(errorCode);

          setIsPasswordResetEmailSend(false);
          setBtnLoader(false);
        });
    }
  };

  return [
    email,
    setEmail,
    ResetPassword,
    EmailError,
    IsPasswordResetEmailSend,
    BtnLoader,
  ];
}
